module.exports = __webpack_public_path__ + "static/img/EC@2x.58646bed.jpg";